<template>
  <div name="noticeboard">
    <button
      type="button"
      class="inline-flex items-center text-center  border-0 mr-0 hover:opacity-75 focus:bg-transparent focus:outline-none"
      @click="selectShowBoard()"
    >
      <i class="far fa-bell pr-2 text-lg"></i> Messages

      <div
        v-if="unreadCount > 0"
        class="inline-flex items-center justify-center w-6 h-6 text-xs p-3 font-semibold text-white bg-red-400 rounded-full ml-2"
      >
        {{ unreadCount }}
      </div>
    </button>
    <template>
      <ModalSlide
        :show="showBoard"
        :headCss="'bg-opacity-25'"
        @closeModal="selectShowBoard"
      >
      <template v-slot:header-icon>
        <i class="fas fa-bell"></i>
      </template>
        <template v-slot:header-title>
            <h2 class="text-xl font-bold">Notifications</h2>
        </template>
        <template v-slot:body>
          <div v-show="showBoard" class="-mt-4 -mx-3">
            <div
              class="flex justify-between w-full p-3 border-b border-gray-200 border-solid"
            >
              <div>
                <button
                  v-if="hasPostSelected"
                  @click="selectedPost = null"
                  class="text-blue-500 text-sm focus:bg-white focus:outline-none"
                >
                  <i class="fas fa-chevron-left pt-4 pl-2"></i> Back
                </button>
              </div>

              <button
                v-if="!hasPostSelected"
                @click="userDidSelectMarkAll()"
                class="text-blue-500 text-sm focus:bg-white focus:outline-none"
              >
                Mark all as read
              </button>
            </div>

            <div v-if="!hasPostSelected" class="flex flex-col space-y-0 w-full">
              <div class="overflow-y-scroll h-screen w-full">
                <div
                  v-for="post in parsedNotices"
                  :key="post.id"
                  @click="userDidSelectPost(post)"
                  class="flex justify-between py-6 px-4 border-b border-gray-300 cursor-pointer border-solid hover:opacity-75"
                  :class="[isRead(post) ? 'bg-white ' : 'bg-blue-100 ']"
                >
                  <div class="flex items-top space-x-4">
                    <template v-if="hasAvatar(post)">
                      {{ setAvatar(post) }}
                      <img
                        v-bind:src="link"
                        class="rounded-full h-12 w-12"
                        :alt="post.user.name"
                      />
                    </template>

                    <div
                      v-else
                      class="content-center h-12 w-12 rounded-full text-center bg-gray-300 bg-opacity-75 p-1"
                    >
                      {{ getUserInitials(post.user) }}
                    </div>

                    <div class="flex flex-col space-y-1 w-10/12 text-left">
                      <div class="font-bold text-base">
                        {{ post.user.name }}
                      </div>
                      <div class="flex-none text-gray-500 text-sm">
                        {{ parsePostedDate(post) }}
                      </div>

                      <div class="text-sm">{{ post.outline }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="opacity-50" />
              <div class="w-full text-center h-16 pt-5 cursor-pointer">
                <button
                  class="text-blue-500 font-bold focus:bg-white focus:outline-none"
                >
                  View all notifications
                </button>
              </div>
              <!-- Item -->
            </div>
            <div v-else class="overflow-y-scroll h-screen w-full text-left p-4 pb-20">
              <h2 class="text-base font-bold">{{ selectedPost.title }}</h2>
              <p class="" v-html="selectedPost.detail"></p>
            </div>
          </div>
        </template>
      </ModalSlide>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

import { fileResourceMixin } from "@/mixins/file-ResourceMixin.js";
import { postMixin } from "@/mixins/postMixin.js";

const ModalSlide = () => import("@/components/ModalSlide.vue");
export default {
  name: "noticeboard",
  mixins: [fileResourceMixin, postMixin],
  props: {},
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    hasPostSelected() {
      return this.selectedPost != null;
    },
  },
  data() {
    return {
      showBoard: false,
      selectedPost: null,
      link: ""
    };
  },
  mounted() {
    this.fetchNotices();
  },
  methods: {
    selectShowBoard() {
      this.showBoard = !this.showBoard;
    },
    parsePostedDate(post) {
      let date = moment(post.posted_date, "YYYY-MM-DD HH:mm:ss GMT Z");
      const timestamp = date.diff(Date.now(), "days");

      return timestamp < -7 ? date.format("Do MMMM YYYY") : date.fromNow();
    },
    getUserInitials(user) {
      return user.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3);
    },
    hasAvatar(post) {
      return post.user.avatar != undefined || post.user.avatar != null;
    },
    isRead(post) {
      return (
        this.reads.find((r) => r.post_identifier === post.identifier) !=
        undefined
      );
    },
    setAvatar(post) {
    //  setTimeout(() => {
        this.getAvatar(post.user.avatar)
          .then((f) => {
            this.link = f;
          })
          .catch((err) => {
            console.log(err);
          });
      //}//, 1000);
    },
    userDidSelectPost(post) {
      this.selectedPost = post;
      this.processMark([post]);
    },
    userDidSelectMarkAll() {
      this.processMark(this.notices);
    },
  },
  components: {
    ModalSlide,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
